import ApplicationAdapter from '../application';

export default class Base extends ApplicationAdapter {
  namespace = 'goals/v4';

  pathForType() {
    return super
      .pathForType(...arguments)
      .replace('goals/', '')
      .toLowerCase();
  }
}
